import AURetrieveSecurityGroupDetails from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/RetrieveSecurityGroupDetails/AURetrieveSecurityGroupDetails';
import NZRetrieveSecurityGroupDetails from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/RetrieveSecurityGroupDetails/NZRetrieveSecurityGroupDetails';

export { AURetrieveSecurityGroupDetails };
export { NZRetrieveSecurityGroupDetails };
